/* tslint:disable */
/* eslint-disable */
/* @relayHash c54217ecc3dfe15f9714026cd2762cbd */

import { ConcreteRequest } from "relay-runtime";
export type AutomatedCheckModal_Run_MutationVariables = {
    verificationUUID: string;
    idExpiry?: string | null;
};
export type AutomatedCheckModal_Run_MutationResponse = {
    readonly runAutoVerify: {
        readonly success: boolean;
        readonly shouldSendToHuman: boolean;
        readonly application: {
            readonly success: boolean;
            readonly errors: ReadonlyArray<string>;
        };
        readonly reference: {
            readonly success: boolean;
            readonly errors: ReadonlyArray<string>;
        };
        readonly interview: {
            readonly success: boolean;
            readonly errors: ReadonlyArray<string>;
        };
        readonly ident: {
            readonly success: boolean;
            readonly errors: ReadonlyArray<string>;
        };
        readonly dbs: {
            readonly success: boolean;
            readonly errors: ReadonlyArray<string>;
        };
    };
};
export type AutomatedCheckModal_Run_Mutation = {
    readonly response: AutomatedCheckModal_Run_MutationResponse;
    readonly variables: AutomatedCheckModal_Run_MutationVariables;
};



/*
mutation AutomatedCheckModal_Run_Mutation(
  $verificationUUID: UUID!
  $idExpiry: Time
) {
  runAutoVerify(verificationUUID: $verificationUUID, idExpiryDate: $idExpiry) {
    success
    shouldSendToHuman
    application {
      success
      errors
    }
    reference {
      success
      errors
    }
    interview {
      success
      errors
    }
    ident: id {
      success
      errors
    }
    dbs {
      success
      errors
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "verificationUUID",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "idExpiry",
            "type": "Time",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        (v1 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "errors",
            "args": null,
            "storageKey": null
        } as any)
    ], v3 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "runAutoVerify",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "idExpiryDate",
                    "variableName": "idExpiry"
                },
                {
                    "kind": "Variable",
                    "name": "verificationUUID",
                    "variableName": "verificationUUID"
                }
            ],
            "concreteType": "RunAutoVerifyResponse",
            "plural": false,
            "selections": [
                (v1 /*: any*/),
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shouldSendToHuman",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "application",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AutoVerifyStageResponse",
                    "plural": false,
                    "selections": (v2 /*: any*/)
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "reference",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AutoVerifyStageResponse",
                    "plural": false,
                    "selections": (v2 /*: any*/)
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "interview",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AutoVerifyStageResponse",
                    "plural": false,
                    "selections": (v2 /*: any*/)
                },
                {
                    "kind": "LinkedField",
                    "alias": "ident",
                    "name": "id",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AutoVerifyStageResponse",
                    "plural": false,
                    "selections": (v2 /*: any*/)
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "dbs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AutoVerifyStageResponse",
                    "plural": false,
                    "selections": (v2 /*: any*/)
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "AutomatedCheckModal_Run_Mutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v3 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "AutomatedCheckModal_Run_Mutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v3 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "AutomatedCheckModal_Run_Mutation",
            "id": null,
            "text": "mutation AutomatedCheckModal_Run_Mutation(\n  $verificationUUID: UUID!\n  $idExpiry: Time\n) {\n  runAutoVerify(verificationUUID: $verificationUUID, idExpiryDate: $idExpiry) {\n    success\n    shouldSendToHuman\n    application {\n      success\n      errors\n    }\n    reference {\n      success\n      errors\n    }\n    interview {\n      success\n      errors\n    }\n    ident: id {\n      success\n      errors\n    }\n    dbs {\n      success\n      errors\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'cb698850e6ac3e01d7203e3172f6516c';
export default node;
